  export const envName = window._env.envName
  export const API_URL=window._env.apiPath//"https://pmxapi-beta.stonex.com:443"
  export const WSRATEPATH=window._env.wsRatePath//"wss://pmxwsr-beta.stonex.com:443"
  export const WSORDERPATH=window._env.wsOrderPath//"wss://pmxwso-beta.stonex.com:443"
  export const LSPATH = window._env.lightStreamerPath
  export const FWD_API_URL = window._env.fwdApiPath
  //export const MONGOAPIPATH=window._env.mongoPath//"https://pmx-beta.stonex.com/mongo"

//LOGIN STATUS
export const LOGGED_IN = "true";
export const LOGGED_OUT = "false";
// commom consts
export const REQUESTED = "_REQUESTED";
export const SUCCESS = "_SUCCESS";
export const FAILED = "_FAILURE";

//HTTP Action
export const HTTP_ACTION = "HTTP_ACTION";

//Http Action request,receive and failure
export const HTTP_ACTION_REQUEST = "HTTP_ACTION_REQUEST";
export const HTTP_ACTION_SUCCESS = "HTTP_ACTION_SUCCESS";
export const HTTP_ACTION_FAILED = "HTTP_ACTION_FAILED";
